/*
import React, { useEffect } from 'react';

const MyComponent = () => {
    useEffect(() => {
         // Check if the script is already present
        const scriptId = 'main-js-jquery';
        if (document.getElementById(scriptId)) {
            // Script already loaded, do nothing
            return;
        }
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `${window.location.origin}/js/main.js`;
        script.onload = () => {
            if (window.$) {
                console.log('jQuery loaded:', window.$);
                // You can now use jQuery
                window.$('#some-id').hide();
            }
        };
        document.body.appendChild(script);

        // return () => {
        //     document.body.removeChild(script);
        // };
    }, []);

    return <></>;
};

export default MyComponent;
*/
import React, { useEffect } from "react";

const MyComponent = () => {
  useEffect(() => {
    // Check if the script is already present
    /*const scriptId = 'main-js-jquery';
        if (document.getElementById(scriptId)) {
            // Script already loaded, do nothing
            return;
        }*/
    const script = document.createElement("script");
    // script.id = scriptId;
    script.src = `${window.location.origin}/js/main.js`;
    script.onload = () => {
      if (window.$) {
        console.log("jQuery loaded:", window.$);
        // You can now use jQuery
        window.$("#some-id").hide();
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <></>;
};

export default MyComponent;
